export const sarSubjectRoleInSuspiciousActivityTypes = [
  { label: 'Purchaser/Sender', value: 'Purchaser/Sender' },
  { label: 'Payee/Receiver', value: 'Payee/Receiver' },
  { label: 'Both', value: 'Both' }
]
